import { Stack } from '@mui/material';
import { ReactNode, FC } from 'react';
import { VyDivider } from '../../../../../../components/new-design/atoms';

type ChargeEditDrawerContentContainer = {
  children: ReactNode;
  rowGap?: number | undefined;
};

export const ChargeEditDrawerContentContainer: FC<ChargeEditDrawerContentContainer> = ({
  children,
  rowGap = 3,
}) => {
  return (
    <Stack direction="column" divider={<VyDivider />} sx={{
      rowGap: rowGap
    }}>
      {children}
    </Stack>
  );
};
